import type { Dayjs } from 'dayjs';
import type { WatchSearchItemsType } from '../types/result';

/**
 * カスタマイズ設定で無効化された検索項目を null 化した値を返す
 * #2642 担当者フィルタ追加と合わせて、検索条件抽出の重複ロジックを集約
 */
export interface EnabledSearchInputs {
  responsiblePerson: string | null;
  /** 担当者UID（#2642） */
  assignee: string | null;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  ocrStatus: number | null;
  /**
   * 要注意の絞り込み（#3262・needsReviewFilterType）。
   * カスタマイズ設定の対象外（常に有効）なので isFieldEnabled は通さない。
   */
  needsReview: number | undefined;
}

/**
 * `WatchSearchItemsType` を、検索カスタマイズ設定（isFieldEnabled）で
 * 無効化された項目を null に置き換えた `EnabledSearchInputs` に変換する。
 *
 * Algolia / Firestore どちらの検索呼び出しでも、この入力を共通の起点として
 * 使うことで、フィルタ条件の抽出ロジックを 1 箇所にまとめる。
 */
export const extractEnabledSearchInputs = (
  watchItems: WatchSearchItemsType,
  isFieldEnabled: (fieldName: string) => boolean,
): EnabledSearchInputs => ({
  responsiblePerson: isFieldEnabled('created_by') ? watchItems.responsiblePerson : null,
  assignee: isFieldEnabled('assignee') ? (watchItems.assignee ?? null) : null,
  startDate: isFieldEnabled('date_range') ? watchItems.startDate : null,
  endDate: isFieldEnabled('date_range') ? watchItems.endDate : null,
  ocrStatus: isFieldEnabled('ocr_status') ? (watchItems.ocrStatus ?? null) : null,
  needsReview: watchItems.needsReview,
});
